import { getDate, parse, format, parseISO, addMinutes, differenceInMinutes } from "date-fns";
import { format as formattz } from 'date-fns-tz';
import { parsePhoneNumber } from "libphonenumber-js";
import { appSettings } from "../data";
import { isLocalDev } from "./environment";
import { tr } from "date-fns/locale";
export const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSS';
export const DEFAULT_PAGE_SIZE = 25
export const ACCEPTED_IMAGE_FILE_FORMAT = ['image/jpeg', 'image/png', 'image/jpg']

export const randomColor = () => Math.floor(Math.random() * 16777215).toString(16).padEnd(6, 'ff');

export const eventSlotColor = (day) => {
    return ['A5D6A7', 'E57373', '42A5F5', 'FFB74D', 'FFD600', 'CDDC39', '00BCD4', 'B388FF', '26C6DA', '00C853'
    ].at(day);
}

export const debounce = (fn, wait = 0) => {
    let timeout;

    return (...args) => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => console.log("test"), wait);
    }
}

/**
 * input format
 * This function will handle UTC dates (e.g. "2025-09-06T13:16:39.433Z") by:
 * 1. If input is Date object - formats it using Intl.DateTimeFormat in local timezone
 * 2. If input is ISO string - parseISO() will parse the UTC date and format() will convert to local timezone
 * Example: "2025-09-06T13:16:39.433Z" -> "Sep, 06 2025" in local timezone
 * @returns date in Month, day year format e.g. Nov 12, 2022
 */

export const niceDate = (dateString, inFormat) => {
    if (!dateString) return '';
    try {
        if (dateString instanceof Date) {
            const op = {
                dateStyle: 'full'
            };
            return new Intl.DateTimeFormat('en-CA', op).format(dateString);
        }
        return format(parseISO(dateString, inFormat || 'yyyy-MM-dd HH:mm:ss.SSS', new Date()), 'MMM, dd yyyy');
    } catch (error) {
        throw new Error(`Invalid date/time format provided.Input value: ${dateString}. Original error: ${error.message}`);
    }
}

export const niceTime = (timeString, inFormat, iso = true) => {
    
    if (timeString) {
        try {
            // 
            return iso ?
                format(parseISO(timeString, inFormat || 'yyyy-MM-dd HH:mm:ss.SSS', new Date()), 'hh:mm a') :
                format(parse(timeString, inFormat || 'HH:mm', new Date()), 'hh:mm a');
        } catch (error) {
            if(isLocalDev) {
                console.log(error);
            }
            throw new Error(error);
        }
    }

}

/**
 * input format dd/mm/yyyy
 * @returns date in Month, day year format
 */
export const formateDate = (dateString, inFormat, outFormat) => {
    try {

        return format(parseISO(dateString, inFormat || 'dd/MM/yyyy', new Date()), outFormat || 'MMM, dd yyyy');
    } catch (error) {
        throw new Error(error);
    }
}

/**
 * Given a date in ISO 8601 format will return date only
 * @param {*} date 
 * @param {*} outFormat 
 * @returns 
 */
export const getDateString = (date, outFormat) => {
    return formateDate(date, 'yyyy-MM-dd HH:mm:ss.SSS', outFormat || 'yyyy-MM-dd');
}


/**
 * Given a date in ISO 8601 format will return date only
 * @param {*} date 
 * @param {*} outFormat 
 * @returns 
 */
export const getDateStringNonISO = (date, outFormat) => {
    return formateDate(date.toISOString(), 'yyyy-MM-dd HH:mm:ss.SSS', outFormat || 'yyyy-MM-dd');
}

/**
 * Given a date in ISO 8601 format will return time only
 * @param {*} date 
 * @param {*} outFormat 
 * @returns 
 */
export const getTimeString = (date, outFormat) => {
    return formateDate(date, 'yyyy-MM-dd HH:mm:ss.SSS', outFormat || 'HH:mm');
}

export const getTimeStringNonIso = (date, outFormat) => {
    return formateDate(date.toISOString(), 'yyyy-MM-dd HH:mm:ss.SSS', outFormat || 'HH:mm');
}

export const dateFromString = (dateString, inFormat, iso = false) => {
    if (iso)
        return parseISO(dateString);

    return parse(dateString, inFormat || 'yyyy-MM-dd', new Date())
}

/**
 * returns date with time
 * @param {Date} forDate 
 * @param {String} timeString 
 * @returns 
 */
export const dateSetTime = (forDate, timeString) => {
    const date = dateFromString(forDate, 'yyyy-MM-dd', true);

    const newStart = timeFromString(timeString);
    newStart.setFullYear(date.getFullYear());
    newStart.setMonth(date.getMonth());
    newStart.setDate(date.getDate());

    return newStart;
}

export const formatTime = (timeString) => {
    return format(parse(timeString, 'HH:mm', new Date()), 'HH:mm')
}

/**
 * given a time in HH:mm format will return diff in minutes
 * @param {string} time1 
 * @param {string} time2 
 */
export const timeDiff = (time1, time2) => {
    let t1 = null,
        t2 = null;
    //if has a space then is in ISO format otherwise is just time
    if (time1.indexOf(' ') > 0) {
        t1 = parse(time1, DATE_FORMAT, new Date());
        t2 = parse(time2, DATE_FORMAT, new Date());
    } else {
        t1 = parse(time1, 'HH:mm', new Date());
        t2 = parse(time2, 'HH:mm', new Date());
    }

    return Math.abs(differenceInMinutes(t2, t1));
}

/**
 * returns date in local timezone
 * @param {Date} date 
 */
export const toLocalTimeZone = (date) => {
    return formattz(date, DATE_FORMAT, { timeZone: appSettings.timeZone });
}

/**
 * breaks a timestring into hour and min component
 * @param {string} timeString 
 * @returns 
 */
export const timeComponent = (timeString) => {
    const hour = +timeString.split(':')[0];
    const minutes = +timeString.split(':')[1];

    return {
        hour: hour,
        minutes: minutes
    }
}

/**
 * 
 * @returns day of month
 */
export const today = () => {
    var result = getDate(new Date());
    return result;
}

/**
 * 
 * @returns day of week
 */
export const dayOfWeek = () => {
    var result = getDate(new Date());
    return result;
}

/**
 * 
 * @param {*} month 
 * @returns string representation of month
 */
export const getMonthString = (month) => {
    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].at(month);
}

export const weekdays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export const getDayString = (day) => {
    return ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].at(day);
}

export const toTitleCase = (str) => {
    return str ? str.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ') : '';
}

export const formatDateWithTimezone = (value, inFormat) => {
    if (!value) return '';
    // if date is not in ISO format then return as is
    if (!value.includes('T')) {
        return value;
    }
    
    // if (value.indexOf(' ') > 0) {
    const date = parseISO(value);
    const adjustedDate = addMinutes(date, date.getTimezoneOffset());
    return format(adjustedDate, inFormat || 'yyyy-MM-dd') //'MM/dd/yyyy');
};


export const getCurrentUTCDate = () => new Date().toISOString();

/**
 * Converts a local Date or string to an ISO 8601 UTC string (e.g., '2025-06-28T14:30:00Z').
 * Useful for sending dates from client to server.
 *
 * @param input - A Date object or a string parseable by new Date()
 * @returns ISO 8601 UTC string
 */
export function formatDateForServer(input) {
    let date;

    if (input instanceof Date) {
        date = input;
    } else if (typeof input === 'string') {
        // Only accept ISO 8601 or timestamps
        const parsed = Date.parse(input);
        if (isNaN(parsed)) {
            throw new Error('Invalid date string — must be ISO 8601 or timestamp.');
        }
        date = new Date(parsed);
    } else {
        throw new Error('Invalid input — must be Date or ISO string.');
    }

    return date.toISOString(); // UTC string
}

/**
 * Checks if a string is a valid ISO 8601 date-time format and parsable by Date.
 * @param str - input date string
 * @returns true if valid ISO 8601 format and valid date
 */
export function isValidIsoDateString(str) {
    if (typeof str !== 'string') return false;

    // ISO 8601 full datetime regex (date + T + time + optional offset/Z)
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?(Z|[\+\-]\d{2}:\d{2})$/;

    if (!isoRegex.test(str)) return false;

    const date = new Date(str);
    return !isNaN(date.getTime());
}

/**
 * returs adrr No street city
 * @param {*} address 
 * @returns 
 */
export const buildAddress = (address) => {
    return `${address.addrNo} ${toTitleCase(address.addrStreet)}, ${toTitleCase(address.addrCity)}`;
}

/**
 * returns hour with 0 padding
 * @param {date} date 
 * @returns 
 */
const getHour = (date) => {
    return ('00' + date.getHours()).slice(-2);
}

/**
 * returns minutes with 0 padding
 * @param {date} date 
 * @returns 
 */
const getMinutes = (date) => {
    return ('00' + date.getMinutes()).slice(-2);
}

export function timeFromString(param) {
    if (!param) return null;

    let format = 'HH:mm';
    const paramlc = param.toLowerCase();
    if (paramlc.endsWith('am') || paramlc.endsWith('pm')) {
        format = `hh:mm a`;
    }

    const dt = parse(paramlc, format, new Date());
    return dt;
    // var d = new Date();
    // var parts = string.split(' ');
    // let timePart = parts[0];
    // let ampm = 'am';

    // let h = +timePart.split(":")[0];
    // let m = +timePart.split(":")[1];

    // // check for am/pm
    // if (parts.length > 1) {
    //     ampm = parts[1].toLowerCase();

    //     if (ampm === 'pm') {
    //         h += 12;
    //     }
    // }


    // d.setHours(h);
    // d.setMinutes(m);
    // d.setSeconds(0);

    // return d;
}

/**
 * given a start and an end with a step will return time range.
 * default step is 15 min
 * @param {Object} start {hh: h, mm: m, ampm: ampm}
 * @param {Object} end {hh: h, mm: m, ampm: ampm}
 * @param {number} step xx (in minutes)
 */
export const getTimeRange = (start, end, step, availableStart, availableEnd, skipRange, endInclusive = false) => {
    const startDate = new Date();
    const endDate = new Date();


    // check for 24 hour
    // 11 pm
    // if( start.ampm === 'pm' && start.h <= 12 ) {
    //     start.h += 12;
    // }        
    // if( end.ampm === 'pm' && end.h <= 12 ) {
    //     end.h += 12;
    // }    

    // startDate.setHours(start.h);
    // startDate.setMinutes(start.m)

    // endDate.setHours(end.h);
    // endDate.setMinutes(end.m)

    // if( start <= 12 ) {
    //     start += 12;
    // }        
    // if( end <= 12 ) {
    //     end+= 12;
    // }    

    startDate.setHours(start);
    startDate.setMinutes(0)

    endDate.setHours(end);
    endDate.setMinutes(0)
    const range = [];

    if (availableStart) {
        const beginFromTime = timeComponent(availableStart);

        startDate.setHours(beginFromTime.hour);
        startDate.setMinutes(beginFromTime.minutes);

    }
    if (availableEnd) {
        const endToTime = timeComponent(availableEnd);

        endDate.setHours(endToTime.hour);
        endDate.setMinutes(endToTime.minutes);
    }

    let s = addMinutes(startDate, 0);

    for (let i = startDate.getTime(); i <= endDate.getTime(); i += step * 60 * 1000) {

        const h = getHour(s);
        const m = getMinutes(s);

        const time = `${h}:${m}`;
        const displaytime = `${h > 12 ? h - 12 : h}:${m} ${h >= 12 ? 'PM' : 'AM'}`;


        startDate.setHours(s.getHours());
        startDate.setMinutes(s.getMinutes());
        let skipIt = false;
        for (var sk = 0; sk < skipRange.length; sk++) {
            const skip = skipRange[sk];
            const timeLower = timeFromString(skip.starttime);
            const timeUpper = timeFromString(skip.endtime);

            if (startDate >= timeLower && startDate < timeUpper) {
                skipIt = true;
                break;
            }
        }

        !skipIt && range.push({ time: time, display: displaytime });
        s = addMinutes(startDate, step);
    }

    if (!endInclusive) range.pop();

    return range;
}

export const getRandomNumber = (min, max) => {
    return Math.round(Math.random() * (max - min) + min);
}

export const getEventCoordinates = (ev) => {
    let target = ev;

    return {
        clientX: target.clientX,
        clientY: target.clientY,
        pageX: target.pageX,
        pageY: target.pageY
    }
}

export const formatPhoneNumber = (phone) => {
    return parsePhoneNumber(`+1${phone}`).formatNational();
}

/**
 * given a file size will return a human readable form
 * @param {*} bytes 
 * @returns 
 */
export function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
  
  /**
   * The Object.keys(obj) method returns an array of an object's own enumerable property names. 
   * If the length of this array is zero, it means the object has no properties and is considered empty.
   * @param {*} obj 
   * @returns 
   */
 export function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
  }

  export function passwordStrength(password) {
    let strength = 0;
    let feedback = [];

    // Strong minimum length requirement
    if (password.length >= 12) {
        strength += 30;
    } else if (password.length >= 8) {
        strength += 15;
        feedback.push("Use at least 12 characters for better security.");
    } else {
        feedback.push("Password is too short.");
    }

    // Uppercase check
    if (/[A-Z]/.test(password)) {
        strength += 15;
    } else {
        feedback.push("Add uppercase letters.");
    }

    // Lowercase check
    if (/[a-z]/.test(password)) {
        strength += 15;
    } else {
        feedback.push("Add lowercase letters.");
    }

    // Numbers check
    if (/\d/.test(password)) {
        strength += 15;
    } else {
        feedback.push("Include at least one number.");
    }

    // Special characters check
    if (/[^A-Za-z0-9]/.test(password)) {
        strength += 15;
    } else {
        feedback.push("Add special characters (e.g., !@#$%).");
    }

    // Common pattern check
    // const commonPatterns = ["1234", "password", "qwerty", "1111"];
    // if (commonPatterns.some(pattern => password.toLowerCase().includes(pattern))) {
    //     strength -= 30;
    //     feedback.push("Avoid common words or sequences.");
    // }

    // Repeating characters check
    if (/(\w)\1{2,}/.test(password)) {
        strength -= 15;
        feedback.push("Avoid repeated characters.");
    }

    // Normalize the strength score to 100-point scale
    strength = Math.max(0, Math.min(strength, 100));

    return strength
};

////////////////////////////////////////////////////////////////////
// Money-related utility functions
////////////////////////////////////////////////////////////////////
/**
 * Parses a string or number into a float, returning 0 for invalid inputs.
 * @param {string|number} value - The value to parse.
 * @returns {number} - The parsed float or 0 if invalid.
 */
export function parseMoney(value) {
  if (typeof value === 'string') {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }
  return typeof value === 'number' ? value : 0;
}

/**
 * Sums an array of money values with high precision.
 * It handles both numbers and strings (e.g., '19.99') in the array.
 * To maintain precision, it avoids direct floating-point addition and instead
 * uses integer arithmetic by scaling values.
 *
 * @param {Array<number|string>} moneyValues An array of money values (numbers or strings).
 * @param {number} [decimalPlaces=2] The number of decimal places to consider for precision.
 * Commonly 2 for currencies.
 * @returns {number} The precise sum of the money values.
 * @throws {TypeError} If any value in the array cannot be converted to a valid number.
 */
export function sumMoney(moneyValues, decimalPlaces = 2) {
  if (!Array.isArray(moneyValues)) {
    throw new TypeError('Input must be an array of money values.');
  }

  if (!Number.isInteger(decimalPlaces) || decimalPlaces < 0) {
    throw new TypeError('decimalPlaces must be a non-negative integer.');
  }

  const multiplier = Math.pow(10, decimalPlaces);
  let totalCents = 0;

  for (let i = 0; i < moneyValues.length; i++) {
    const value = moneyValues[i];
    const preciseNum = parseMoney(value);

    // Scale to an integer to avoid floating point issues during summation
    totalCents += Math.round(preciseNum * multiplier);
  }

  // Scale back to the original decimal representation
  return totalCents / multiplier;
}

// Adds an array of monetary values safely using cent-based arithmetic
export function sumMoneyDEP(values) {
  const totalCents = values.reduce((sum, val) => {
    const amount = typeof val === 'number' ? val : 0;
    return sum + Math.round(amount * 100);
  }, 0);
  return totalCents / 100;
}

// Optional: truncating version (not rounding)
export function sumMoneyTruncateDEP(values) {
  const totalCents = values.reduce((sum, val) => {
    const amount = typeof val === 'number' ? val : 0;
    return sum + Math.floor(amount * 100);
  }, 0);
  return totalCents / 100;
}

// A small epsilon value to account for floating-point inaccuracies
const EPSILON = Number.EPSILON;

export function truncateToTwoDecimals(amount, decimalPlaces = 2) {
  if (typeof amount !== 'number' || isNaN(amount)) {
    throw new TypeError('Value must be a valid number. value: ' + amount);
  }
  if (!Number.isInteger(decimalPlaces) || decimalPlaces < 0) {
    throw new TypeError('decimalPlaces must be a non-negative integer.');
  }

  const multiplier = Math.pow(10, decimalPlaces);
  return Math.round((amount + EPSILON) * multiplier) / multiplier;
}

/**
 * Formats a number into a display string with a "$" symbol and two decimal places.
 * Always shows "$" regardless of currency code or locale.
 * 
 * @param {number|string} value - The amount to format.
 * @param {string} [currency='CAD'] - The currency code (default is 'CAD').
 * @returns {string} - Formatted currency string like "$1,234.56"
 */
export function formatAmountForDisplays(amount, currency = 'CAD') {
    //const truncatedAmount = truncateToTwoDecimals(parseMoney(amount));
    // if (isNaN(truncatedAmount)) {
    //     return '';
    // }

    if (typeof amount !== 'string') {
        amount = String(amount);
    }

  // Round to exactly 2 decimal places using toFixed
  const [whole, decimal = '00'] = amount.split('.');

  // Truncate or pad to exactly 2 digits
  const safeDecimal = (decimal + '00').slice(0, 2);

// const formatted = new Intl.NumberFormat(['en-US'], {
//     style: 'currency',
//     currency: currency,
//   }).format(rounded);

  const formatted = new Intl.NumberFormat(['en-US'], {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(whole));

  //const formattedAmount = numberFormat.format(truncatedAmount);

  return formatted === 'NaN' ? '' : `$${formatted}.${safeDecimal}`;
}

/**
 * Formats a number into a display string with a "$" symbol and two decimal places.
 * Always shows "$" regardless of currency code or locale.
 *
 * @param {number|string} value - The amount to format.
 * @param {string} [currency='CAD'] - The currency code (default is 'CAD').
 * @returns {string} - Formatted currency string like "$1,234.56"
 */
export function formatAmountForDisplay(value) {
  if (typeof value !== 'string') {
    value = String(value);
  }

  const [whole, decimal = '00'] = value.split('.');

  // Truncate or pad to exactly 2 digits
  const safeDecimal = (decimal + '00').slice(0, 2);

  const formattedWhole = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Number(whole));

  return `$${formattedWhole}.${safeDecimal}`;
}

/**
 * Formats an amount for display with currency symbol and formatting from business preferences
 * Uses currencySymbol, locale, currencyPosition, thousandsSeparator, and decimalSeparator from preferences
 * 
 * @param {number|string} amount - The amount to format
 * @param {Object} [preferences] - Business preferences object with currency-related fields
 * @returns {string} - Formatted currency string (e.g., "$1,234.56" or "1.234,56€")
 * 
 * @example
 * // With preferences: { currencySymbol: '€', locale: 'fr-CA', currencyPosition: 'after', thousandsSeparator: '.', decimalSeparator: ',' }
 * formatAmountForDisplayWithPreferences(1234.5, preferences); // "1.234,50€"
 * 
 * // Without preferences (uses defaults: $ and en-US with currencyPosition: 'before')
 * formatAmountForDisplayWithPreferences(1234.5); // "$1,234.50"
 */
export function formatAmountForDisplayWithPreferences(amount, preferences) {
  try {
    // Handle null/undefined
    if (amount === null || amount === undefined) {
      return '';
    }

        // Normalize numeric input first so we never render a negative zero value.
        const numericAmount = Number(amount);
        const normalizedAmount = Number.isFinite(numericAmount) && Math.abs(numericAmount) < 0.000001
            ? 0
            : amount;

        // Convert to string for parsing
        if (typeof normalizedAmount !== 'string') {
            amount = String(normalizedAmount);
        } else {
            amount = normalizedAmount;
        }

    // Get currency preferences with defaults
    const currencySymbol = preferences?.currencySymbol || '$';
    const locale = preferences?.locale || 'en-US';
    const currencyPosition = preferences?.currencyPosition || 'before';
    const thousandsSeparator = preferences?.thousandsSeparator || ',';
    const decimalSeparator = preferences?.decimalSeparator || '.';

    // Split on decimal point
    const [whole, decimal = '00'] = amount.split('.');

    // Truncate or pad to exactly 2 digits
    const safeDecimal = (decimal + '00').slice(0, 2);

    // Format whole number with thousand separators using preference locale
    let formattedWhole = new Intl.NumberFormat(locale, {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Number(whole));

    // Replace the default locale-based separators with preference-based ones
    // Intl.NumberFormat uses locale-specific separators, so we need to normalize them
    const localeThousandsSep = new Intl.NumberFormat(locale).format(1000).charAt(1); // Get locale's thousands separator
    
    formattedWhole = formattedWhole.replace(new RegExp(localeThousandsSep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), thousandsSeparator);

    const formattedAmount = `${formattedWhole}${decimalSeparator}${safeDecimal}`;

    // Apply currency position
    return currencyPosition === 'after' 
      ? `${formattedAmount}${currencySymbol}`
      : `${currencySymbol}${formattedAmount}`;
  } catch (error) {
    console.warn('formatAmountForDisplayWithPreferences error:', error, 'for amount:', amount);
    return '';
  }
}

// Helper function to calculate the total for a single invoice item
// This function uses the item's current values or a newValue if provided for a specific field update.
export const calculateItemTotal = (item, field, newValue) => {
    // 1. Get current values (handling potential updates from field/newValue)
    const quantity = field === 'quantity' ? parseFloat(newValue) || 1 : (item.quantity || 1);
    const price = item.price || 0;
    const taxPercentage = field === 'tax' ? parseFloat(newValue) || 0 : (item.tax || 0);
    const discountPercentage = field === 'discount' ? parseFloat(newValue) || 0 : (item.discount || 0);

    // 2. Calculate initial subtotal (quantity * price)
    const subtotal = quantity * price;

    // 3. Calculate discount amount and apply it to the subtotal
    const discountAmount = truncateToTwoDecimals((discountPercentage / 100) * subtotal);
    const discountedSubtotal = subtotal - discountAmount; // <--- Discount applied here!

    // 4. Calculate tax amount on the discounted subtotal
    const taxAmount = (taxPercentage / 100) * discountedSubtotal; // <--- Tax applied to the discounted value!

    // 5. Final total
    const total = discountedSubtotal + taxAmount;
    //console.log('calculateItemTotal', { quantity, price, subtotal, discountAmount, discountedSubtotal, taxAmount, total });
    // Round to two decimal places (assuming truncateToTwoDecimals does this, or you might want to apply it to 'total' as the last step)
    return total;
};


// Helper function to calculate the discount amount for a single *item*
export const calculateItemDiscountAmount = (item) => {
    const subtotal = (item.quantity || 0) * (item.price || 0);
    const discountPercentage = item.discount || 0;

    return truncateToTwoDecimals((discountPercentage / 100) * subtotal);
};

// Helper function to calculate the tax amount for a single *item*
// this should include overall discount also
export const calculateItemTaxAmount = (item) => {
    const subtotal = (item.quantity || 1) * (item.price || 0);
    const discountPercentage = item.discount || 0;
    const taxPercentage = item.tax || 0;

    
    const discountedSubtotal = subtotal - (discountPercentage / 100) * subtotal;
    return truncateToTwoDecimals((taxPercentage / 100) * discountedSubtotal);
};

// Helper function to calculate the total overall discount amount from promotions/discounts list
// applied to the line items subtotal.
export const calculateTotalOverallDiscountAmount = (discounts, lineItemsSubtotal) => {
    let totalDiscount = 0;
    if (!discounts || !Array.isArray(discounts)) {
        return 0;
    }

    discounts.forEach(discount => {
        if (!discount || lineItemsSubtotal <= 0) {
            return; // Skip invalid discounts
        }
        if (discount.type.toLowerCase() === 'percentage') {
            const percentage = Math.max(0, Math.min(100, parseMoney(discount.value)));
            totalDiscount += (percentage / 100) * lineItemsSubtotal;
        } else if (discount.type.toLowerCase() === 'fixed') {
            totalDiscount += parseMoney(discount.value); // Sum fixed amounts
        }
    });

    // Optional: Cap total discount at the lineItemsSubtotal if fixed amounts could exceed it
    return Math.min(truncateToTwoDecimals(totalDiscount), lineItemsSubtotal);
};